import React, { useEffect, useState, useRef } from 'react'
// import { useHistory } from 'react-router-dom'
import { Col, Button, Modal, Form, Input, Card, Select } from 'antd'
// import { useSelector } from 'react-redux'
import { SearchOutlined } from '@ant-design/icons'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
// import { clearAuthentication } from '@/utils/authHelp'
import {
  getUserAdd,
  userUpdate,
  getUserList,
  getUserDelete,
  getSystemFactoryGroup
} from '@/services/UserManagement/userManagement'
import { getRoleList } from '@/services/RoleManagement/RoleManagement'
import { paginationInit, formatMessage } from '@/utils/common'
import { modalConfirm, messageModal } from '@/utils/modalUtils'
import { regEmail } from '@/utils/regUtils'
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 }
  }
}
const UserManagement = () => {
  // let commonStore = useSelector(state => state.commonStore)
  let formRef = useRef(null)
  const [initForm] = Form.useForm()
  // const history = useHistory()
  const [tableList, setTableList] = useState([])
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [rolesList, setRolesList] = useState([])
  const [factoryGroupList, setFactoryGroupList] = useState([])
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [queryFlag, setQueryFlag] = useState(false)
  let saveParam = {}
  const [pagination, setPagination] = useState(paginationInit)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.userManagementLocale.email',
      key: 'loginEmail',
      initialValues: '',
      spans: {
        xl: 6,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.roleManagementLocale.roleName',
      key: 'roleName',
      initialValues: null,
      allowClear: true,
      selectList: [],
      spans: {
        xl: 6,
        xxl: 6
      }
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  const initDataFrom = {
    loginEmail: '',
    username: '',
    roleIdList: [],
    factoryGroup: '全部'
  }
  const [dataFrom, setDataFrom] = useState(initDataFrom)
  const tableColumns = [
    {
      title: formatMessage('languageObj.userManagementLocale.email'),
      dataIndex: 'loginEmail',
      width: 100,
      render: (text, record) => {
        return (
          <div onClick={() => addAndEdit(record)} className="link_name">
            {text}
          </div>
        )
      }
    },
    {
      title: formatMessage('languageObj.userManagementLocale.userId'),
      dataIndex: 'username',
      width: 100,
      render: text => {
        return <div>{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.userManagementLocale.role'),
      dataIndex: 'roleList',
      width: 200,
      render: text => {
        return <div>{(text.map(item => item.roleName) || []).join(',')}</div>
      }
    },
    {
      title: formatMessage('languageObj.userManagementLocale.factoryGroup'),
      dataIndex: 'factoryGroup',
      width: 200,
      render: text => {
        return <div>{text}</div>
      }
    }
  ]
  useEffect(() => {
    searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  useEffect(() => {
    getRoleListFun()
    getSystemFactoryGroupFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const getRoleListFun = () => {
    getRoleList({}).then(res => {
      let dt = res.resultData.records
      setRolesList(dt)
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'roleName') {
          let uniqueRes = []
          switch (itemFirst.key) {
            case 'roleName':
              uniqueRes = dt.map(item => {
                return {
                  label: item.roleName,
                  value: item.roleName
                }
              })
              break
            default:
              uniqueRes = []
              break
          }
          itemFirst.selectList = uniqueRes
        }
      })
      setSearchList([...searchListInit])
    })
  }
  const getSystemFactoryGroupFun = () => {
    getSystemFactoryGroup({
      configType: 'factory_group_code'
    }).then(res => {
      let dt = res.resultData
      setFactoryGroupList(dt)
    })
  }
  const searchDataBtn = () => {
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchDataFun = () => {
    setSelectedRowKeys([])
    let info = {}
    info = (formRef.current && formRef.current.getValue()) || {}
    const params = {
      ...info,
      userStatus: true,
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getUserList(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const deleteUser = () => {
    modalConfirm(
      {
        title: formatMessage('languageObj.commonLocale.delete'),
        content: formatMessage('languageObj.userManagementLocale.deleteUserTip')
      },
      () => {
        const loginEmails = selectedRowKeys.map(item => {
          return `loginEmails=${tableList[item].loginEmail}`
        })
        let params = loginEmails.join('&')
        getUserDelete(params).then(res => {
          messageModal('success', { content: formatMessage('languageObj.commonLocale.success') })
          if (selectedRowKeys.length === tableList.length) {
            const pag = {
              ...pagination,
              currentPage: pagination.currentPage - 1 || 1
            }
            setPagination({ ...pag })
          }
          setQueryFlag(!queryFlag)
        })
      }
    )
  }
  const addAndEdit = record => {
    setVisibleFlag(true)
    initForm.resetFields()
    if (record) {
      record.roleIdList = record.roleList.map(item => item.id)
      setDataFrom(record)
      initForm.setFieldsValue(record)
    } else {
      setDataFrom(initDataFrom)
      initForm.setFieldsValue(initDataFrom)
    }
  }
  // const checkOwnInfo = values => {
  //   const accountLogin = commonStore.account
  //   return accountLogin === values.username ? true : false
  // }
  const handleUserOk = () => {
    initForm
      .validateFields()
      .then(values => {
        let params = {
          ...dataFrom,
          ...values
        }
        if (dataFrom.id) {
          // 修改
          saveParam = params
          modalConfirm({ content: formatMessage('languageObj.userManagementLocale.changeRoleTip') }, () => {
            handleConfirmOk(params)
          })
        } else {
          // 新增
          saveFun(params, () => {
            messageModal('success', { content: formatMessage('languageObj.commonLocale.success') })
            handleUserCancel()
            setQueryFlag(!queryFlag)
          })
        }
      })
      .catch(errorInfo => {
        console.log(errorInfo)
      })
  }
  const handleConfirmOk = params => {
    let updateParams = {
      ...params,
      id: saveParam.id,
      loginEmail: saveParam.loginEmail,
      roleIdList: saveParam.roleIdList,
      username: saveParam.username
    }
    userUpdate(updateParams).then(() => {
      messageModal('success', { content: formatMessage('languageObj.commonLocale.success') })
      handleUserCancel()
      setQueryFlag(!queryFlag)
      // if (checkOwnInfo(saveParam)) {
      //   // 是自己
      //   setTimeout(() => {
      //     clearAuthentication()
      //     history.push('/login')
      //   }, 2000)
      // } else {
      //   // 不是自己
      // }
    })
  }
  const saveFun = (params, cb) => {
    getUserAdd(params).then(res => {
      cb && cb()
    })
  }
  const handleUserCancel = () => {
    setVisibleFlag(false)
  }
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    // getCheckboxProps: record => ({
    //   disabled: record.username === commonStore.account
    // }),
    onChange: onSelectChange
  }
  const hasSelected = selectedRowKeys.length > 0
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRef} searchList={searchList}>
            <Col
              xs={24}
              sm={12}
              md={12}
              lg={8}
              xl={6}
              xxl={6}
              className="right_search"
              style={{ justifyContent: 'flex-end' }}
            >
              <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
                {formatMessage('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessage('languageObj.commonLocale.clear')}</Button>
            </Col>
          </SearchBar>
        </div>
      </Card>
      <Card className="mt15">
        <div className="content-container">
          <div className="mb15">
            <Button type="primary" onClick={() => addAndEdit()}>
              {formatMessage('languageObj.commonLocale.addNew')}
            </Button>
            <Button type="primary" className="ml20" disabled={!hasSelected} onClick={deleteUser}>
              {formatMessage('languageObj.commonLocale.delete')}
            </Button>
          </div>
          <AntdTable
            rowSelection={rowSelection}
            dataSource={tableList}
            columns={tableColumns}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        width="40%"
        title={
          dataFrom.id
            ? formatMessage('languageObj.commonLocale.edit')
            : formatMessage('languageObj.commonLocale.addNew')
        }
        onOk={handleUserOk}
        onCancel={handleUserCancel}
      >
        <Form form={initForm} {...formItemLayout}>
          <Form.Item
            label={formatMessage('languageObj.userManagementLocale.email')}
            name="loginEmail"
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (value) {
                    if (regEmail.test(value)) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error(formatMessage('languageObj.userManagementLocale.checkNikeEmailFormat'))
                      )
                    }
                  } else {
                    return Promise.reject(
                      new Error(
                        formatMessage('languageObj.userManagementLocale.email') +
                          formatMessage('languageObj.commonLocale.isRequired')
                      )
                    )
                  }
                }
              }
            ]}
            initialValue={dataFrom.loginEmail}
          >
            <Input
              allowClear
              maxLength={100}
              disabled={dataFrom.id ? true : false}
              placeholder={formatMessage('languageObj.commonLocale.placeholderInput')}
            />
          </Form.Item>
          <Form.Item
            label={formatMessage('languageObj.userManagementLocale.userId')}
            name="username"
            rules={[
              {
                required: true,
                message:
                  formatMessage('languageObj.userManagementLocale.userId') +
                  formatMessage('languageObj.commonLocale.isRequired')
              }
            ]}
            initialValue={dataFrom.username}
          >
            <Input allowClear maxLength={20} placeholder={formatMessage('languageObj.commonLocale.placeholderInput')} />
          </Form.Item>
          <Form.Item
            label={formatMessage('languageObj.userManagementLocale.role')}
            name="roleIdList"
            rules={[
              {
                required: true,
                message:
                  formatMessage('languageObj.userManagementLocale.role') +
                  formatMessage('languageObj.commonLocale.isRequired')
              }
            ]}
            initialValue={dataFrom.roleIdList}
          >
            <Select
              showSearch
              allowClear
              mode="multiple"
              // 修复不出滚动条的bug
              listItemHeight={45}
              style={{ width: '100%' }}
              placeholder={formatMessage('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {(rolesList || []).map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item.id}>
                    {item.roleName}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label={formatMessage('languageObj.userManagementLocale.factoryGroup')}
            name="factoryGroup"
            rules={[
              {
                required: true,
                message:
                  formatMessage('languageObj.userManagementLocale.factoryGroup') +
                  formatMessage('languageObj.commonLocale.isRequired')
              }
            ]}
            initialValue={dataFrom.factoryGroup}
          >
            <Select
              showSearch
              // 修复不出滚动条的bug
              listItemHeight={45}
              style={{ width: '100%' }}
              placeholder={formatMessage('languageObj.commonLocale.placeholderSelect')}
              optionFilterProp="children"
              filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            >
              {(factoryGroupList || []).map((item, idx) => {
                return (
                  <Select.Option key={idx} value={item}>
                    {item}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default UserManagement
